import { NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { TrapFocusDirective } from '../../../shared/directives/trap-focus.directive';

@Component({
    selector: 'app-menu-services[closePopover]',
    templateUrl: './menu-services.component.html',
    styleUrls: ['./menu-services.component.scss'],
    standalone: true,
    imports: [TrapFocusDirective, TranslateModule, NgOptimizedImage],
})
export class MenuServicesComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    readonly tissueUrl = environment.tissueUrl;
    readonly automatedGenotypingUrl = environment.automatedGenotypingUrl;
    readonly geneticMonitoringUrl = environment.geneticMonitoringUrl;
    readonly microbiomeUrl = environment.microbiomeUrl;
    readonly colonyUrl = environment.colonyUrl;
    readonly tagCenterUrl = 'https://tagcenter.info/';

    close(): void {
        this.closePopover.emit();
    }
}
